import * as React from 'react'

const SolvemojiSelect = React.memo((props: any) => (
  <div>
    <select {...props} className='pa__input form-control'>
      {
        props.children
      }
    </select>
    <div className='invalid-feedback' />
  </div>
))

export default SolvemojiSelect
